import { createStyles } from 'antd-style';

export const useAccountStyles = createStyles(({ css, token }) => ({
  authShell: css`
    position: fixed;
    inset: 0;
    box-sizing: border-box;
    min-height: 100vh;
    overflow: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 32px 24px;
    background: url('/assets/background.svg') center / cover no-repeat;

    @media (max-width: 760px) {
      padding: 28px 16px;
    }
  `,
  brandHeader: css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    gap: 12px;
    height: 80px;
    margin-bottom: 125px;

    img {
      width: 50px;
      height: 50px;
      object-fit: contain;
    }

    strong {
      color: ${token.colorText};
      font-size: 22px;
      font-weight: 700;
      line-height: 1;
    }

    @media (max-width: 760px) {
      margin-bottom: 48px;
    }
  `,
  loginPanel: css`
    position: relative;
    flex: 0 0 auto;
    width: 680px;
    height: 490px;
    overflow: hidden;
    border-radius: 8px;
    background: ${token.colorBgContainer};
    box-shadow: 0 10px 30px rgba(58, 65, 102, 0.1);

    @media (max-width: 760px) {
      width: min(100%, 432px);
      height: 490px;
    }
  `,
  formPane: css`
    position: absolute;
    inset: 0 auto 0 0;
    width: 432px;
    height: 490px;

    @media (max-width: 760px) {
      width: 100%;
    }
  `,
  loginInner: css`
    position: relative;
    width: 432px;
    height: 490px;

    @media (max-width: 760px) {
      width: 100%;
    }
  `,
  modeSwitch: css`
    position: absolute;
    top: 48px;
    left: 96px;
    box-sizing: border-box;
    width: 240px;
    height: 40px;
    padding: 2px;
    border: 1px solid ${token.colorPrimaryBorder};
    border-radius: 12px;
    background: ${token.colorBgContainer};

    .ant-segmented-group {
      width: 100%;
      display: flex;
    }

    .ant-segmented-item {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      color: ${token.colorPrimary};
    }

    .ant-segmented-item-label {
      width: 100%;
      text-align: center;
      line-height: 34px;
    }

    @media (max-width: 460px) {
      left: 50%;
      transform: translateX(-50%);
    }
  `,
  singleModeTitle: css`
    position: absolute;
    top: 48px;
    left: 96px;
    box-sizing: border-box;
    width: 240px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid ${token.colorPrimaryBorder};
    border-radius: 12px;
    color: ${token.colorPrimary};
    font-size: 16px;
    font-weight: 500;

    @media (max-width: 460px) {
      left: 50%;
      transform: translateX(-50%);
    }
  `,
  formArea: css`
    position: absolute;
    top: 120px;
    left: 32px;
    width: 368px;

    .ant-form-item-label {
      display: none;
    }

    .ant-input,
    .ant-input-password,
    .ant-select-selector {
      font-size: 16px;
    }

    .account-phone-input {
      width: 100%;
      height: 54px;
    }

    .account-captcha-button {
      height: 54px;
      color: ${token.colorTextQuaternary};
      line-height: 54px;
      white-space: nowrap;
    }

    .account-captcha-button:not(.ant-typography-disabled) {
      color: ${token.colorPrimary};
    }

    .account-captcha-button:not(.ant-typography-disabled):hover {
      color: ${token.colorPrimary};
    }

    .account-agreement-checkbox {
      align-items: center;
      color: ${token.colorTextSecondary};
      font-size: 12px;
    }

    .account-agreement-checkbox .ant-checkbox + span {
      padding-inline-start: 8px;
      white-space: nowrap;
    }

    @media (max-width: 460px) {
      left: 24px;
      width: calc(100% - 48px);
    }
  `,
  captchaButton: css`
    width: 120px;
    height: 54px;
    padding: 0;
    justify-content: center;
    color: ${token.colorTextQuaternary};

    &:hover {
      color: ${token.colorPrimary};
    }
  `,
  oauthContainer: css`
    position: absolute;
    top: 330px;
    left: 32px;
    width: 368px;
    padding-top: 20px;

    @media (max-width: 460px) {
      left: 24px;
      width: calc(100% - 48px);
    }
  `,
  oauthDivider: css`
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    color: ${token.colorTextTertiary};
    font-size: 12px;

    &::before,
    &::after {
      content: '';
      flex: 1;
      height: 1px;
      background: ${token.colorBorderSecondary};
    }

    span {
      padding: 0 12px;
      white-space: nowrap;
    }
  `,
  oauthGrid: css`
    display: flex;
    justify-content: center;
    gap: 24px;
  `,
  oauthButton: css`
    min-width: auto;
    height: 33px;
    padding: 6px;
    border: 1px solid ${token.colorBorderSecondary};
    border-radius: 16px;
    color: ${token.colorText};
    background: ${token.colorBgContainer};
    font-size: 12px;
    text-decoration: none;
    transition: all ${token.motionDurationMid};

    &:hover {
      border-color: ${token.colorPrimary};
      box-shadow: ${token.boxShadowSecondary};
      transform: translateY(-2px);
    }
  `,
  brandPane: css`
    position: absolute;
    top: 8px;
    left: 432px;
    width: 240px;
    height: 474px;
    overflow: hidden;
    border-radius: 4px;
    background: url('/assets/login-user-bg.png') center / cover no-repeat;

    @media (max-width: 760px) {
      display: none;
    }
  `,
  tenantShell: css`
    min-height: 100vh;
    padding: ${token.paddingXL}px;
    background: ${token.colorBgLayout};

    @media (max-width: 720px) {
      padding: ${token.padding}px;
    }
  `,
  tenantPanel: css`
    position: relative;
    width: 680px;
    height: 432px;
    overflow: hidden;
    border-radius: 8px;
    background: ${token.colorBgContainer};
    box-shadow: 0 10px 30px rgba(58, 65, 102, 0.1);

    @media (max-width: 760px) {
      width: min(100%, 432px);
    }
  `,
  tenantPane: css`
    position: absolute;
    inset: 0 auto 0 0;
    width: 432px;
    height: 432px;

    @media (max-width: 760px) {
      width: 100%;
    }
  `,
  tenantHeader: css`
    position: absolute;
    top: 62px;
    left: 32px;
    width: 368px;

    .ant-typography {
      margin: 0;
    }

    h3.ant-typography {
      margin-bottom: 8px;
      font-size: 20px;
      font-weight: 600;
    }

    @media (max-width: 460px) {
      left: 24px;
      width: calc(100% - 48px);
    }
  `,
  tenantList: css`
    position: absolute;
    top: 140px;
    left: 32px;
    width: 368px;
    max-height: 200px;
    overflow: auto;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding-right: 4px;

    @media (max-width: 460px) {
      left: 24px;
      width: calc(100% - 48px);
    }
  `,
  tenantEmpty: css`
    position: absolute;
    top: 144px;
    left: 32px;
    width: 368px;

    @media (max-width: 460px) {
      left: 24px;
      width: calc(100% - 48px);
    }
  `,
  tenantSubmit: css`
    position: absolute;
    top: 356px;
    left: 32px;
    width: 368px;
    height: 44px;
    border-radius: ${token.borderRadius}px;
    font-size: 16px;

    @media (max-width: 460px) {
      left: 24px;
      width: calc(100% - 48px);
    }
  `,
  primaryLink: css`
    display: inline-flex;
    min-height: 32px;
    align-items: center;
    justify-content: center;
    padding: 4px 15px;
    border-radius: ${token.borderRadius}px;
    background: ${token.colorPrimary};
    color: ${token.colorTextLightSolid};
    text-decoration: none;

    &:hover {
      background: ${token.colorPrimaryHover};
      color: ${token.colorTextLightSolid};
    }

    &:focus-visible {
      outline: 2px solid ${token.colorPrimaryBorder};
      outline-offset: 2px;
    }
  `,
  tenantContent: css`
    width: min(980px, 100%);
    margin: 0 auto;
  `,
  tenantGrid: css`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: ${token.margin}px;
    margin-top: ${token.marginLG}px;
  `,
  tenantCard: css`
    width: 100%;
    height: 56px;
    padding: 12px 16px;
    border: 1px solid ${token.colorBorderSecondary};
    border-radius: 2px;
    background: ${token.colorBgContainer};
    display: flex;
    align-items: center;
    gap: 12px;
    text-align: left;
    cursor: pointer;
    transition: border-color ${token.motionDurationMid}, box-shadow ${token.motionDurationMid}, background ${token.motionDurationMid};

    &:hover {
      border-color: ${token.colorPrimaryBorder};
      box-shadow: ${token.boxShadowSecondary};
    }
  `,
  tenantCardActive: css`
    border: 2px solid ${token.colorPrimary};
    box-shadow: 0 0 0 2px rgba(83, 55, 166, 0.2);
  `,
  tenantCardDisabled: css`
    opacity: 0.65;
  `,
  tenantCardText: css`
    min-width: 0;
    flex: 1;
    strong {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: ${token.colorText};
      font-size: 14px;
      font-weight: 400;
    }
  `,
  tenantAvatar: css`
    width: 22px;
    height: 22px;
    flex: 0 0 22px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: ${token.colorTextSecondary};
    background: ${token.colorFillTertiary};
    font-size: 14px;
  `,
  tenantDisabledText: css`
    color: ${token.colorError};
    font-size: 12px;
  `,
  tenantBrandPane: css`
    position: absolute;
    top: 8px;
    left: 432px;
    width: 240px;
    height: 416px;
    overflow: hidden;
    border-radius: 4px;
    background: url('/assets/login-tenant-bg.png') center / cover no-repeat;

    @media (max-width: 760px) {
      display: none;
    }
  `,
  callbackBox: css`
    width: min(480px, 100%);
    padding: ${token.paddingXL}px;
    border: 1px solid ${token.colorBorderSecondary};
    border-radius: ${token.borderRadiusLG}px;
    background: ${token.colorBgContainer};
    text-align: center;
    box-shadow: ${token.boxShadowSecondary};
  `,
  joinPanel: css`
    box-sizing: border-box;
    width: min(432px, 100%);
    min-height: 360px;
    padding: 48px 32px 32px;
    border-radius: 8px;
    background: ${token.colorBgContainer};
    box-shadow: 0 10px 30px rgba(58, 65, 102, 0.1);

    h3.ant-typography {
      margin-bottom: 8px;
      font-size: 20px;
    }
  `,
  joinField: css`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 32px;
    color: ${token.colorTextSecondary};
    font-size: 14px;

    .ant-input {
      height: 44px;
      color: ${token.colorText};
    }
  `,
  joinAlert: css`
    margin-top: 20px;
  `,
  joinSubmit: css`
    height: 44px;
    margin-top: 24px;
    font-size: 16px;
  `,
  joinAddPanel: css`
    position: relative;
    box-sizing: border-box;
    width: min(432px, 100%);
    height: 432px;
    border-radius: 8px;
    background: ${token.colorBgContainer};
    box-shadow: 0 10px 30px rgba(58, 65, 102, 0.1);

    @media (max-width: 460px) {
      height: 420px;
    }
  `,
  joinAddBack: css`
    position: absolute;
    top: 12px;
    left: 20px;
    height: 38px;
    padding-inline: 12px;

    &:focus-visible {
      outline: 2px solid ${token.colorPrimaryBorder};
      outline-offset: 2px;
    }
  `,
  joinAddHeading: css`
    position: absolute;
    top: 94px;
    left: 32px;
    width: 368px;

    h3.ant-typography {
      margin: 0 0 2px;
      font-size: 20px;
      font-weight: 500;
      line-height: 28px;
    }

    .ant-typography {
      margin: 0;
      color: ${token.colorText};
      font-size: 20px;
      font-weight: 500;
      line-height: 28px;
    }

    @media (max-width: 460px) {
      left: 24px;
      width: calc(100% - 48px);
    }
  `,
  joinAddEmoji: css`
    display: inline-block;
    margin-left: 8px;
    font-size: 26px;
    line-height: 28px;
    vertical-align: -2px;
  `,
  joinAddConsultant: css`
    position: absolute;
    top: 214px;
    left: 32px;
    width: 368px;

    @media (max-width: 460px) {
      left: 24px;
      width: calc(100% - 48px);
    }
  `,
  joinAddPhone: css`
    display: flex;
    align-items: center;
    gap: 8px;
    height: 24px;
    margin-top: 8px;
    color: ${token.colorText};
    font-size: 16px;
  `,
  joinAddApplication: css`
    position: absolute;
    top: 300px;
    left: 32px;
    width: 368px;

    @media (max-width: 460px) {
      left: 24px;
      width: calc(100% - 48px);
    }
  `,
  joinAddApplicationRow: css`
    display: flex;
    gap: 8px;
    margin-top: 8px;
  `,
  joinAddLinkBox: css`
    box-sizing: border-box;
    min-width: 0;
    height: 32px;
    flex: 1;
    display: flex;
    align-items: center;
    padding-left: 10px;
    border: 1px solid ${token.colorBorder};
    border-radius: 2px;
    background: ${token.colorBgContainer};
  `,
  joinAddLinkText: css`
    min-width: 0;
    flex: 1;
    overflow: hidden;
    color: ${token.colorText};
    font-size: 12px;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,
  joinAddCopy: css`
    height: 30px;
    flex: 0 0 auto;
    padding-inline: 8px;
    color: ${token.colorPrimary};
    font-size: 14px;
  `,
  joinAddOpen: css`
    width: 80px;
    height: 32px;
    flex: 0 0 80px;
    padding-inline: 8px;
    border-radius: 2px;
    font-size: 14px;
  `,
}));
